import Vue from 'vue'
import VueI18n from 'vue-i18n'

import en from './locale/en.json'
import es from './locale/es.json'
import it from './locale/it.json'

Vue.use(VueI18n)

const locale = 'en'

const messages = {
  en: en,
  es: es,
  it: it
}

const i18n = new VueI18n({
  locale,
  messages
})

export default i18n



// WEBPACK FOOTER //
// ./src/lang/lang.js